


















import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { DrawerSubItem } from '@/interfaces/drawer'

@Component({
  components: {}
})
export default class SubMenuDrawer extends Vue {
  @Prop({ type: Array as () => DrawerSubItem[] }) readonly menuList!: DrawerSubItem[]

  showDrawer = false

  clock: any = null

  active: number = -1

  @Watch('$route', { deep: true })
  onRouteChange (val: any) {
    const routeName = val.meta && val.meta.menu ? val.meta.menu : val.name
    this.setActive(routeName)
  }

  @Watch('menuList', { deep: true })
  onMenuListChange (val: DrawerSubItem[]) {
    const routeName = this.$route.meta && this.$route.meta.menu ? this.$route.meta.menu : this.$route.name
    this.setActive(routeName)
  }

  mounted () {
    this.onMenuListChange(this.menuList)
  }

  onMouseIn () {
    window.clearTimeout(this.clock)
    this.showDrawer = true
  }

  onMouseOut () {
    this.clock = setTimeout(() => {
      this.showDrawer = false
    }, 100)
  }

  setActive (routeName: string) {
    this.active = -1
    for (const [i, p] of this.menuList.entries()) {
      if (routeName === p.routeTo) {
        this.active = i
        break
      }
    }
  }

  @Emit('click')
  onClick (item: DrawerSubItem, index: number) {
    this.active = index
    return item
  }
}
